import { useAppActions } from 'reducers/slices/chatsSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { loadChats, updateChat } = useAppActions();
  const { chatsLoadingStatus, chats, chatUpdatingStatus } = useSelector(state => state.chatsSlice);

  return {
    loadChats,
    chatsLoadingStatus,
    isChatsLoading: useFetchStatus(chatsLoadingStatus).isPending,
    chats,
    isChatsLoaded: useFetchStatus(chatsLoadingStatus).isFulfilled,
    isUpdating: useFetchStatus(chatUpdatingStatus).isPending,
    updateChat,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useChats.js